import React from 'react';
import NextStep, { HeaderStep } from './step';

const StepsList: React.FC<{ steps: HeaderStep[] }> = ({ steps }) => {
	return (
		<>
			{steps.length > 0 && (
				<div className="max-w-xl text-font text-lg flex flex-col m-auto gap-5 lg:gap-9">
					{steps.map((step, index) => (
						<NextStep
							key={'step-' + index}
							name={step.name}
							icon={step.icon}
							title={step.title}
							description={step.description}
						/>
					))}
				</div>
			)}
		</>
	);
};

export default StepsList;
